import TeamLanding from './TeamLanding'

export default TeamLanding
